import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CreateNewGroupButton from './CreateNewGroupButton';
import { preferencesGroupsStorage } from '../../services/preferencesGroupsStorage';
import DeletePreferenceGroupPopup from './DeletePreferenceGroupPopup';
import PreferenceGroupsList from './PreferenceGroupsList';
import PreferenceGroupsTable from './PreferenceGroupsTable';
import SearchItemBlock from '../../shared/SearchItemBlock';
import ContentTitle from '../../shared/ContentTitle';
import PreferenceGroupsActions from './PreferenceGroupsActions';
import { useListViewMode } from '../../shared/listView/useListViewMode';
import ListViewSwitcher from '../../shared/listView/ListViewSwitcher';

const PreferenceGroupList = () => {
    const { i18n } = useTranslation();
    const { mode, setMode, isTableForcedOff } = useListViewMode('preference-group', { defaultMode: 'tile' });
    const [, setRevision] = useState(0);
    const [ready, setReady] = useState(false);

    const handleLoadPreferenceGroups = () => {
        preferencesGroupsStorage.loadItems(() => setRevision((value) => value + 1));
    };

    useEffect(() => {
        const onChange = () => {
            setReady(true);
            setRevision((value) => value + 1);
        };
        preferencesGroupsStorage.loadItems(onChange);
        preferencesGroupsStorage.registerFiltersChangingObserver(onChange);
        return () => {
            preferencesGroupsStorage.unRegisterFiltersChangingObserver(onChange);
            preferencesGroupsStorage.changeSelectedPreferenceGroups('', true);
        };
    }, []);

    return (
        <>
            <DeletePreferenceGroupPopup notifyPreferencesGroupsList={handleLoadPreferenceGroups} />
            <SearchItemBlock
                itemsStorageService={preferencesGroupsStorage}
                placeholder={i18n.t('preference.scheme.groups.placeholder')}
                actions={
                    <>
                        <CreateNewGroupButton />
                        <ListViewSwitcher
                            mode={mode}
                            onChange={setMode}
                            disabled={isTableForcedOff}
                        />
                    </>
                }
            />
            <article className="preference__article preference__article_full-width">
                <div className="preference__groups-block">
                    <ContentTitle title={i18n.t('app.page.group.title')} />
                    <PreferenceGroupsActions />
                </div>
                {mode === 'table' ? (
                    <PreferenceGroupsTable
                        items={ready ? preferencesGroupsStorage.getItems() : []}
                    />
                ) : (
                    <PreferenceGroupsList skipLoad />
                )}
            </article>
        </>
    );
};

export default PreferenceGroupList;
